const ComponentsZIndex = {
	Alert: 2000,
	Dialog: 1200,
	Tooltip: 1500
};

export default ComponentsZIndex;


/** WEBPACK FOOTER **
 ** ./src/zindex.js
 **/